import { h } from 'preact';

import styles from './SmallcaseBanner.css';

function SmallcaseBanner(props) {
  return (
    <div class={`text-light ${styles['gateway-logo']}`}>
      Powered by
      <img class={styles['banner-img']} src="/assets/img/gateway-logo.svg" />
    </div>
  );
}

export default SmallcaseBanner;



// WEBPACK FOOTER //
// ./components/SmallcaseBanner/SmallcaseBanner.js